import React from "react";
import { ReactNode } from "react";
import { Tabs } from "react-tabs";
import styled from "styled-components";
import AppContext from "../AppContext";

const StylingTabs = styled(Tabs)<{tabstyle?: any}>`
    .react-tabs {
        -webkit-tap-highlight-color: transparent;
    }
    .react-tabs__tab-list {
        // border-bottom: 1px solid ${(props) => props.tabstyle?.selectedTabBgcColor};
        margin: 0;
        padding: 0;
        display: flex;
    }
    .react-tabs__tab {
        height: 35px;
        line-height: 35px;
        background: #F9F8F9;
        border: 1px solid #DEDEDE;
        border-radius: 10px 10px 0 0; /* 상우하좌 순서 */
        list-style: none;
        cursor: pointer;
        color: #4E4E4E;
        text-align: center;
        font-size: 14px;
        font-family: fm-b;
        letter-spacing: -0.6px;
        flex: 1;
    }
    .react-tabs__tab--selected {
        background: ${(props) => props.tabstyle?.selectedTabBgcColor};
        font-size: 15px;
        color: #fff;
        font-family: fm-c;
    }
    .react-tabs__tab--disabled {
        color: GrayText;
        cursor: default;
    }
    .react-tabs__tab:focus {
        outline: none;
    }
    .react-tabs__tab:focus:after {
        content: '';
        background: #fff;
    }
    .react-tabs__tab-panel {
        display: none;
    }
    .react-tabs__tab-panel--selected {
        display: block;
    }
`;

interface StyledTabsProps {
    children: ReactNode
    selectedIndex?: number
    className?: string
}
const StyledTabs = ({children, selectedIndex, className}: StyledTabsProps) => {
    if (selectedIndex === undefined) {
        return (
            <StylingTabs className={className ? className : ""}>
                {children}
            </StylingTabs>
        )
    }
    return (
        <StylingTabs tabstyle={{
            selectedTabBgcColor: AppContext.themeColor
        }} selectedIndex={selectedIndex} className={className ? className : ""} onSelect={() => {}}>
            {children}
        </StylingTabs>
    )
}
export default React.memo(StyledTabs);